// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__5EfnM","footer__socials":"footer_footer__socials__qKK4D"};